//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'

export default {
  name: 'HEART',
  data() {
    return {
      defaultJson: {
        "High": "高危（早期侵袭性救治策略）",
        "Non specific": "非特异性",
        "≤ normal": "≤ 正常",
        "1 to 3× normal limit": "1 - 3 倍正常极限",
        "Non specific repolarisation disturbance": "非特异性复极化异常",
        "Low": "低危（立即出院）",
        "More than 65 years old": "65 岁以上（含）",
        "Slightly": "轻度",
        "≥ 65": "≥ 65",
        "1-2": "1 - 2",
        "More than 2 risk factors or history of atherosclerotic disease": "超过 2 个危险因素或动脉粥样硬化病史",
        "≥3 or Positive Hx": "≥ 3 或阳性病史",
        "None": "无",
        "Moderate": "中危（住院观察）",
        "Highly suspicious": "高度怀疑",
        "EKG": "ECG",
        "More than 3× normal limit": "超过 3 倍正常极限",
        "Risk Factors": "危险因素",
        "No risk factors known": "无明确的危险因素",
        "Lower than normal limit": "低于正常极限",
        "Significant ST-depression": "ST 段明显压低",
        "1-3x normal": "1 - 3 倍正常",
        "Moderately suspicious": "重度怀疑",
        "46-64": "46 - 64",
        "≥ 3x normal": "≥ 3 倍正常",
        "1 to 2 risk factors": "1 - 2 个危险因素",
        "Moderately": "重度",
        "Age": "年龄",
        "Normal": "正常",
        "Troponin": "肌钙蛋白",
        "rfHint": "危险因素包括：• 高脂血症• 高血压• 糖尿病• 吸烟• 家族史• 肥胖",
        "Highly": "高度",
        "Significant": "明显",
        "History": "病史",
        "Less than 45 years old": "45 岁以下（含）",
        "46 to 64 years old": "46 - 64 岁",
        "Slightly suspicious": "轻度怀疑",
        "≤ 45": "≤ 45"
      },
      form: {
        age: '',
        rf: '',
        his: '',
        ekg: '',
        trop: '',
      },
      hasScore: false,
      disabled: false,
      dataList: [
        { value: "0", name: '45 岁以下（含）', shortName: '≤ 45' },
        { value: "1", name: '46 - 64 岁', shortName: '46 - 64' },
        { value: "2", name: '65 岁以上（含）', shortName: '≥ 65' },
      ],
      dataList2: [
        { value: "0", name: '无明确的危险因素"', shortName: '无' },
        { value: "1", name: '1 - 2 个危险因素', shortName: '1 - 2' },
        { value: "2", name: '超过 2 个危险因素或动脉粥样硬化病史', shortName: '≥ 3 或阳性病史' },
      ],
      dataList3: [
        { value: "0", name: '轻度怀疑', shortName: '轻度' },
        { value: "1", name: '重度怀疑', shortName: '重度' },
        { value: "2", name: '高度怀疑', shortName: '高度' },
      ],
      dataList4: [
        { value: "0", name: '正常', shortName: '正常' },
        { value: "1", name: '非特异性复极化异常', shortName: '非特异性' },
        { value: "2", name: 'ST 段明显压低', shortName: '明显' },
      ],
      dataList5: [
        { value: "0", name: '低于正常极限', shortName: '≤ 正常' },
        { value: "1", name: '1 - 3 倍正常极限', shortName: '1 - 3 倍正常极限' },
        { value: "2", name: '超过 3 倍正常极限', shortName: '≥ 3 倍正常' },
      ],
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),

    maxNSum(num, obj) {
      let self = this


    },

  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return ''
      } else {
        // age + rf + his + resp
        let result = form.age + form.rf + form.his + form.ekg + form.trop
        self.hasScore = true
        return String(result)
      }
    }
  },

}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/HEART.vue